export var LoggerEvents;
(function (LoggerEvents) {
    LoggerEvents["GetExtNFTOwner"] = "get-ext-nft-owner";
    LoggerEvents["GetExtNFTIndex"] = "get-ext-nft-index";
    LoggerEvents["GetOrigynNFTOwner"] = "get-origyn-nft-owner";
    LoggerEvents["GetOrigynNFTRawData"] = "get-origyn-nft-raw-data";
    LoggerEvents["GetOrigynOwnershipHistory"] = "get-origyn-ownership-history";
})(LoggerEvents || (LoggerEvents = {}));
//# sourceMappingURL=LoggerEvents.js.map